import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { Breadcrumb, BreadcrumbNav } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-energy-interface-details-breadcrumb-nav',
  imports: [BreadcrumbNav, Breadcrumb, RouterLink, NgIcon, TranslocoPipe],
  templateUrl: './energy-interface-details-breadcrumb-nav.html',
})
export class EnergyInterfaceDetailsBreadcrumbNav {
  organizationId = input.required<string>();
  energyInterfaceId = input.required<string>();
}
